import api from './api';
import { User } from '../types';
import { UserProfile } from './userService';

export interface LoginResponse {
  user: { id: number; name: string; email: string };
  token: string;
  token_type: string;
}

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const { data } = await api.post<LoginResponse>('/login', { email, password });
    return data;
  },

  async logout(): Promise<void> {
    await api.post('/logout');
  },

  async getMe(): Promise<User> {
    // Получаем полный профиль пользователя с аватаркой
    const { data } = await api.get<UserProfile>('/profile');
    return {
      id: data.id,
      name: data.name,
      email: data.email,
      avatar: data.avatar || undefined,
      role: 'user',
    };
  },

  async loginAsUser(userId: number): Promise<LoginResponse & { original_user?: { id: number; name: string; email: string } }> {
    const { data } = await api.post<LoginResponse & { original_user?: { id: number; name: string; email: string } }>(`/users/${userId}/login-as`);
    return data;
  },

  async stopImpersonating(originalUserId: number): Promise<LoginResponse> {
    const { data } = await api.post<LoginResponse>('/stop-impersonating', {
      original_user_id: originalUserId,
    });
    return data;
  },
};
